import { render, staticRenderFns } from "./perfekt-starka-verb.vue?vue&type=template&id=2aab5070&scoped=true"
import script from "./perfekt-starka-verb.vue?vue&type=script&lang=js"
export * from "./perfekt-starka-verb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aab5070",
  null
  
)

export default component.exports